import { HtmlDivProps } from 'framework/components/HtmlDivProps';
import React, { forwardRef } from 'react';

export type RowStackProps = Omit<HtmlDivProps, 'ref'> & {
	dfrow?: boolean;
	dfrowac?: boolean;
	dfrowfs?: boolean;
	dfrowab?: boolean;
	gap?: number;
	w100?: boolean;
	h100?: boolean;
	dfrowwrap?: boolean;
	dfrowac_jcc?: boolean;
	paper?: boolean;
	pointer?: boolean;
	jc_sb?: boolean;
	borderBottomDivider?: boolean;
	errorBorder?: boolean;
	preventDefault?: boolean;
};

function calculateStyle(props: RowStackProps): React.CSSProperties {
	let style = { ...props.style };
	if (props.dfrow === true) {
		style = { ...style, display: 'flex', flexDirection: 'row' };
	}
	if (props.dfrowac === true) {
		style = { ...style, display: 'flex', flexDirection: 'row', alignItems: 'center' };
	}
	if (props.dfrowfs === true) {
		style = { ...style, display: 'flex', flexDirection: 'row', alignItems: 'flex-start' };
	}
	if (props.dfrowab === true) {
		style = { ...style, display: 'flex', flexDirection: 'row', alignItems: 'baseline' };
	}
	if (props.h100 === true) {
		style = { ...style, height: '100%' };
	}
	if (props.w100 === true) {
		style = { ...style, width: '100%' };
	}
	if (props.dfrowwrap === true) {
		style = { ...style, display: 'flex', flexDirection: 'row', flexWrap: 'wrap' };
	}
	if (props.dfrowac_jcc === true) {
		style = { ...style, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' };
	}
	if (props.pointer === true) {
		style = { ...style, cursor: 'pointer' };
	}
	if (props.jc_sb === true) {
		style = { ...style, justifyContent: 'space-between' };
	}
	if (props.borderBottomDivider === true) {
		style = { ...style, borderBottom: '1px solid gray' };
	}
	if (props.errorBorder === true) {
		style = { ...style, borderBottom: '2px solid red', borderRadius: '16px' };
	}
	if (props.gap !== undefined) {
		style = { ...style, gap: `${props.gap * 8}px` };
	}
	return style;
}

const RowStack = forwardRef<HTMLDivElement, RowStackProps>((props, ref) => {
	return (
		<div
			children={props.children}
			onClick={props.onClick}
			ref={ref}
			style={calculateStyle(props)}
		/>
	);
});

export default RowStack;
